import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'hap-unauthorized',
  template: `
        <main class="page-content">
            <h1>You are not authorized to view this page.  You will be redirected.</h1>
        </main>
    `,
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent {    
	constructor(@Inject(DOCUMENT)private _document: any) { 
    }
}
